import { takeLatest, put, call, all, fork } from 'redux-saga/effects';
import RefreshmentApprovalTypes from './RefreshmentApproval.types';
import {
	refreshApproval,
	calculateRefreshment,
	approveRefreshment,
	bulkApproveRefreshment,
	rejectRefreshment,
} from './RefreshmentApproval.services';
import {
	refreshmentApprovalSuccess,
	refreshmentApprovalFailure,
	calculateRefreshmentSuccess,
	calculateRefreshmentFailure,
	approveRefreshmentSuccess,
	approveRefreshmentFailure,
	bulkApproveRefreshmentSuccess,
	bulkApproveRefreshmentFailure,
	rejectRefreshmentSuccess,
	rejectRefreshmentFailure,
} from './RefreshmentApproval.action';
import AlertManager from '../../utils/alertManager';
import { encryptData } from '../_common/enode-decode';

export function* fetchRefreshmentApprovalSaga(payload: any) {
	try {
		const key = "fetchRefreshmentApprovalkey";
				const encryptedData = encryptData(
					payload.payload,key,
				);
		// @ts-ignore
		const responseData = yield call(refreshApproval as any, encryptedData);

		// Handle the response data - it might contain HTML mixed with JSON
		let parsedData = responseData.data;

		// If the response is a string, try to extract JSON from it
		if (typeof responseData.data === 'string') {
			try {
				// Try to find JSON in the response string using a different approach
				const jsonStart = responseData.data.indexOf('{');
				const jsonEnd = responseData.data.lastIndexOf('}');
				if (jsonStart !== -1 && jsonEnd !== -1 && jsonEnd > jsonStart) {
					const jsonString = responseData.data.substring(jsonStart, jsonEnd + 1);
					parsedData = JSON.parse(jsonString);
				}
			} catch (parseError) {
				console.error('Failed to parse JSON from response:', parseError);
			}
		}
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			// Check if we have valid data
			if (parsedData && parsedData.status === 'success' && parsedData.data) {
				yield put(refreshmentApprovalSuccess(parsedData));
			} else if (parsedData && parsedData.data && Array.isArray(parsedData.data)) {
				// If data is directly an array, wrap it in success format
				yield put(
					refreshmentApprovalSuccess({
						status: 'success',
						data: parsedData.data,
					}),
				);
			} else {
				yield put(refreshmentApprovalFailure(parsedData || 'Invalid response format'));
			}
		}
	} catch (error: any) {
		console.error('Saga error:', error);
		yield put(
			refreshmentApprovalFailure(
				error?.response?.data?.message || 'Error fetching refreshment allowance',
			),
		);
	}
}

export function* calculateRefreshmentSaga(payload: any) {
	try {
		const key = "calculateRefreshmentKey";
				const encryptedData = encryptData(
					payload.payload,key,
				);
		// @ts-ignore
		const responseData = yield call(calculateRefreshment as any, encryptedData);

		let parsedData = responseData.data;

		if (typeof responseData.data === 'string') {
			try {
				const jsonStart = responseData.data.indexOf('{');
				const jsonEnd = responseData.data.lastIndexOf('}');
				if (jsonStart !== -1 && jsonEnd !== -1 && jsonEnd > jsonStart) {
					const jsonString = responseData.data.substring(jsonStart, jsonEnd + 1);
					parsedData = JSON.parse(jsonString);
				}
			} catch (parseError) {
				console.error('Failed to parse JSON from response:', parseError);
			}
		}
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (parsedData && parsedData.status === 'success') {
				yield put(calculateRefreshmentSuccess(parsedData));
			} else {
				yield put(calculateRefreshmentFailure(parsedData || 'Invalid response format'));
			}
		}
	} catch (error: any) {
		console.error('Saga error:', error);
		yield put(
			calculateRefreshmentFailure(
				error?.response?.data?.message || 'Error calculating refreshment allowance',
			),
		);
	}
}

export function* approveRefreshmentSaga(payload: any) {
	try {
		const key = "approveRefreshmentKey";
				const encryptedData = encryptData(
					payload.payload,key,
				);

		// @ts-ignore
		const responseData = yield call(approveRefreshment as any, encryptedData);

		let parsedData = responseData.data;

		if (typeof responseData.data === 'string') {
			try {
				const jsonStart = responseData.data.indexOf('{');
				const jsonEnd = responseData.data.lastIndexOf('}');
				if (jsonStart !== -1 && jsonEnd !== -1 && jsonEnd > jsonStart) {
					const jsonString = responseData.data.substring(jsonStart, jsonEnd + 1);
					parsedData = JSON.parse(jsonString);
				}
			} catch (parseError) {
				console.error('Failed to parse JSON from response:', parseError);
			}
		}
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (parsedData && parsedData.status === 'success') {
				yield put(approveRefreshmentSuccess(parsedData));
			} else {
				yield put(approveRefreshmentFailure(parsedData || 'Invalid response format'));
			}
		}
	} catch (error: any) {
		console.error('Saga error:', error);
		yield put(
			approveRefreshmentFailure(
				error?.response?.data?.message || 'Error approving refreshment allowance',
			),
		);
	}
}

export function* bulkApproveRefreshmentSaga(payload: any) {
	try {
		const key = "bulkApproveRefreshmentKey";
				const encryptedData = encryptData(
					payload.payload,key
				);
		// @ts-ignore
		const responseData = yield call(bulkApproveRefreshment as any,encryptedData);

		let parsedData = responseData.data;

		if (typeof responseData.data === 'string') {
			try {
				const jsonStart = responseData.data.indexOf('{');
				const jsonEnd = responseData.data.lastIndexOf('}');
				if (jsonStart !== -1 && jsonEnd !== -1 && jsonEnd > jsonStart) {
					const jsonString = responseData.data.substring(jsonStart, jsonEnd + 1);
					parsedData = JSON.parse(jsonString);
				}
			} catch (parseError) {
				console.error('Failed to parse JSON from response:', parseError);
			}
		}
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (parsedData && parsedData.status === 'success') {
				yield put(bulkApproveRefreshmentSuccess(parsedData));
			} else {
				yield put(bulkApproveRefreshmentFailure(parsedData || 'Invalid response format'));
			}
		}
	} catch (error: any) {
		console.error('Saga error:', error);
		yield put(
			bulkApproveRefreshmentFailure(
				error?.response?.data?.message || 'Error bulk approving refreshment allowances',
			),
		);
	}
}

export function* rejectRefreshmentSaga(payload: any) {
	try {
		const key = "rejectRefreshmentKey";
				const encryptedData = encryptData(
					payload.payload,key
				);
		// @ts-ignore
		const responseData = yield call(rejectRefreshment as any, encryptedData);

		let parsedData = responseData.data;

		if (typeof responseData.data === 'string') {
			try {
				const jsonStart = responseData.data.indexOf('{');
				const jsonEnd = responseData.data.lastIndexOf('}');
				if (jsonStart !== -1 && jsonEnd !== -1 && jsonEnd > jsonStart) {
					const jsonString = responseData.data.substring(jsonStart, jsonEnd + 1);
					parsedData = JSON.parse(jsonString);
				}
			} catch (parseError) {
				console.error('Failed to parse JSON from response:', parseError);
			}
		}
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (parsedData && parsedData.status === 'success') {
				yield put(rejectRefreshmentSuccess(parsedData));
			} else {
				yield put(rejectRefreshmentFailure(parsedData || 'Invalid response format'));
			}
		}
	} catch (error: any) {
		console.error('Saga error:', error);
		yield put(
			rejectRefreshmentFailure(
				error?.response?.data?.message || 'Error rejecting refreshment allowance',
			),
		);
	}
}

export function* onRefreshmentApprovalStart(): Generator<any, void, any> {
	yield takeLatest(
		RefreshmentApprovalTypes.REFRESHMENT_APPROVAL_START as any,
		fetchRefreshmentApprovalSaga,
	);
}

export function* onCalculateRefreshmentStart(): Generator<any, void, any> {
	yield takeLatest(
		RefreshmentApprovalTypes.CALCULATE_REFRESHMENT_START as any,
		calculateRefreshmentSaga,
	);
}

export function* onApproveRefreshmentStart(): Generator<any, void, any> {
	yield takeLatest(
		RefreshmentApprovalTypes.APPROVE_REFRESHMENT_START as any,
		approveRefreshmentSaga,
	);
}

export function* onBulkApproveRefreshmentStart(): Generator<any, void, any> {
	yield takeLatest(
		RefreshmentApprovalTypes.BULK_APPROVE_REFRESHMENT_START as any,
		bulkApproveRefreshmentSaga,
	);
}

export function* onRejectRefreshmentStart(): Generator<any, void, any> {
	yield takeLatest(
		RefreshmentApprovalTypes.REJECT_REFRESHMENT_START as any,
		rejectRefreshmentSaga,
	);
}

export function* refreshmentApprovalSaga(): Generator<any, void, any> {
	yield all([
		fork(onRefreshmentApprovalStart),
		fork(onCalculateRefreshmentStart),
		fork(onApproveRefreshmentStart),
		fork(onBulkApproveRefreshmentStart),
		fork(onRejectRefreshmentStart),
	]);
}
